function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var FETCH_HOME_AIRPORT = 'kupibilet.ru/AviaSearch/HomeAirport/FETCH_HOME_AIRPORT';
export var FETCH_HOME_AIRPORT_SUCCESS = 'kupibilet.ru/AviaSearch/HomeAirport/FETCH_HOME_AIRPORT_SUCCESS';
export var FETCH_HOME_AIRPORT_FAILURE = 'kupibilet.ru/AviaSearch/HomeAirport/FETCH_HOME_AIRPORT_FAILURE';
export var fetchHomeAirport = function fetchHomeAirport(ip) {
  return {
    type: FETCH_HOME_AIRPORT,
    meta: {
      procsFetch: true
    },
    payload: {
      ip: ip
    }
  };
};
export var fetchHomeAirportSuccess = function fetchHomeAirportSuccess(data) {
  return {
    type: FETCH_HOME_AIRPORT_SUCCESS,
    meta: {
      updatesWithFetched: true,
      successOf: FETCH_HOME_AIRPORT
    },
    payload: {
      home: data
    }
  };
};
export var fetchHomeAirportFailure = function fetchHomeAirportFailure() {
  return {
    type: FETCH_HOME_AIRPORT_FAILURE,
    payload: {
      home: null
    }
  };
};
var initialState = {
  home: null
};
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case FETCH_HOME_AIRPORT_SUCCESS:
      {
        return _objectSpread({}, state, {}, action.payload);
      }

    case FETCH_HOME_AIRPORT_FAILURE:
      {
        return _objectSpread({}, state, {}, action.payload);
      }

    default:
      return state;
  }
});